import React from "react";
import bishow from "../assets/bishow-removebg-preview.png";
import { FaUser } from "react-icons/fa";
import { TbMessage2Share } from "react-icons/tb";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <div className=" md:px-0 px-4 py-12 flex justify-center items-center">
      <div className=" h-full md:w-10/12">
        <div className="flex flex-col items-center justify-between lg:flex-row">
          <div>
            <div className="md:w-[650px]">
              <h2
                data-aos-duration="1500"
                data-aos="fade-down"
                className="md:mb-6  mb-5 text-xl font-serif text-primary-400 font-semibold sm:text-3xl"
              >
                {" "}
                message
                <span className=" px-2 inline-block  font-bold  text-accent-300">
                  From
                </span>{" "}
                <span className=" underline">Principal</span>
              </h2>
              <p
                data-aos-duration="1500"
                data-aos="fade-down"
                className=" text-gray-700  md:text-md text-sm  "
              >
                Principal Bishwa Bandhu Subedi leads Holy Vision Technical
                Campus (HVTC) in Thapagaun, New Baneshower Kathmandu Nepal,
                emphasizing academic excellence and holistic student
                development. Under his guidance, HVTC provides top-notch
                facilities and a nurturing environment for future engineers and
                innovators.
              </p>
            </div>
            <div
              data-aos-duration="1500"
              data-aos="slide-right"
              className="mt-10 flex gap-5  md:items-center md:flex-row"
            >
              <Link
                to="https://wa.me/9846904128"
                target="_blank"
                rel="noopener noreferrer"
                className="mb-3 inline-flex h-10 text-sm  w-max items-center justify-center rounded-lg    bg-accent-350 px-6 font-medium tracking-wide text-white shadow-md transition duration-500 md:mr-4 md:mb-0 md:w-auto focus:outline-none hover:bg-accent-300 "
              >
                Chat with us
              </Link>
              <Link
                to="https://www.facebook.com/profile.php?id=61561311225933&sk=reels_tab&__cft__[0]=AZXgmBg4OR0x2HqCP9RgjSObqGGAVSUhXBQ2x7jUviOFgOciKerOXkCJ3UnUMhMTnb2XIQ-gR2pUBal0nIlWHMxzUrwp9aka3iERmOZG3I_CfLwDFzL2l3wrCz_O8bqI9CdtHOzFXa4oj0gTG7KaB6R6JRnKudt_9Zto6Yyms61k2QNU4U6nPoTvUJtnK9ge4Gg"
                aria-label=""
                target="_blank"
                rel="noopener noreferrer"
                className="underline-offset-2 inline-flex md:items-center font-semibold text-blue-600 underline transition-colors duration-200 hover:underline"
              >
                Visit to facebook Channel
              </Link>
            </div>
            <div className="mt-12 flex flex-col space-y-3 divide-gray-300 text-sm text-gray-700 sm:flex-row sm:space-y-0 sm:divide-x">
              <div
                data-aos-duration="1500"
                data-aos="slide-left"
                className="flex  gap-2 justify-center items-center  max-w-xs space-x-2 px-4"
              >
                <FaUser size={25} className="  text-accent-350" />
                <div className=" flex md:flex-col gap-2  md:gap-0">
                  <p className="">Principal</p>
                  <p className=" text-primary-350"> Bishwa Bandhu Subedi</p>
                </div>
              </div>
              <div
                data-aos-duration="1500"
                data-aos="slide-left"
                className="flex gap-2   md:pt-0 pt-3 justify-center items-center max-w-xs space-x-2 px-4"
              >
                <TbMessage2Share size={25} className="  text-accent-350" />
                <div className=" flex md:flex-col  gap-2 md:gap-0">
                  <p>Email :-</p>
                  <p className=" text-primary-350"> bishwo.subedi@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative  lg:block ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mx-auto my-6 h-10 w-10 animate-bounce rounded-full bg-blue-50 p-2 lg:hidden"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16 17l-4 4m0 0l-4-4m4 4V3"
              />
            </svg>
            <div
              data-aos="zoom-in"
              data-aos-duration="1500"
              className="w-fit rounded-[6rem] mx-auto overflow-hidden rounded-tl-none rounded-br-none  bg-primary-450"
            >
              <img className=" h-96" src={bishow} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DirectMessage = () => {
  return (
    <div>
      <HeroSection />
    </div>
  );
};

export default DirectMessage;
